// extracted by mini-css-extract-plugin
module.exports = {"gameCard":"gameCard--VZ0BW"};